module.exports = __webpack_public_path__ + "img/blackwhite_badge_supermin4.b3b2335d.webp";